"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../style/injectSheet"));
var _excluded = ["classes", "className", "component", "theme"];
/*:: // 

import { type ElementType } from 'react';*/
/*:: import { type InjectSheetProvidedProps } from '../style/ThemeTypes';*/
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Style = {
  root: {
    fontWeight: 'bold'
  }
};
/*:: type Props = InjectSheetProvidedProps & {
  /**
   * Component to be used as the heading
   *-/
  component: ElementType
};*/
function MarkdownEmbolden(props /*: Props*/) {
  var classes = props.classes,
    classNameProp = props.className,
    Component = props.component,
    theme = props.theme,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  var className = (0, _classnames.default)(classes.root, classNameProp);
  return /*#__PURE__*/_react.default.createElement(Component, _objectSpread(_objectSpread({}, other), {}, {
    className: className
  }));
}
MarkdownEmbolden.displayName = 'MarkdownEmbolden';
MarkdownEmbolden.defaultProps = {
  component: 'strong'
};
var _default = exports.default = (0, _injectSheet.default)(Style)(MarkdownEmbolden);
//# sourceMappingURL=Embolden.js.map